import React from 'react'
import { Route } from 'react-router-dom'
import { INACTIVE_CAMPAIGN } from 'core/routing/constants'
import ErrorPage from '.'

const router = <Route exact path={INACTIVE_CAMPAIGN} component={ErrorPage} />

export default router
